module.exports = __webpack_public_path__ + "static/media/branding-logo-topbar.17557351.png";